exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".input-quantity[data-v-b2798b3a]{border-bottom:thin solid #494949;background-color:#d8d8d8;border-radius:5px 5px 0 0;padding:3px;font-size:9pt}", "", {"version":3,"sources":["/vercel/path0/src/components/contract/department/Tables.vue"],"names":[],"mappings":"AACA,iCACE,iCAA0C,AAC1C,yBAAqC,AACrC,0BAA+B,AAC/B,YAAa,AACb,aAAe,CAChB","file":"Tables.vue","sourcesContent":["\n.input-quantity[data-v-b2798b3a] {\n  border-bottom: solid thin rgb(73, 73, 73);\n  background-color: rgb(216, 216, 216);\n  border-radius: 5px 5px 0px 0px;\n  padding: 3px;\n  font-size: 9pt;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b2798b3a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contract/department/Tables.vue
// module id = 282
// module chunks = 1 3 4